<template>
  <div v-editable="blok">
    <NavBreadCrumb class="mb-12 lg:mb-16" :title="blok.title" />
    <div class="rte mx-auto max-w-screen-md px-6 md:px-8">
      <h1>{{ blok.title }}</h1>
      <p class="mb-12 text-sm">
        Media Release | {{ formattedDate }} |
        <sbUtilReadTime :article-content="props.blok.articleContent" />
      </p>
      <img
        v-if="!blok.hideImage && blok.image?.filename"
        :src="`${blok.image.filename}/m/1536x864/smart/`"
        :alt="blok.image.alt"
        class="mb-12 w-full rounded-lg"
      />
      <SbUtilRichTextRender :article-content="blok.articleContent" />
      <p class="mt-8 text-xs">
        All information contained in this media release, including references to
        costs, speed, and capability of the Aussie Broadband network, was
        correct at time of publication, and may have since changed.
      </p>
    </div>

    <div
      class="mt-12 border-y border-grey-300 bg-grey-100 px-4 shadow-inner md:px-0"
    >
      <SbMediaCentreEnquiresBlock
        :media-contact-data="mediaContactData"
        :investor-contact-data="investorContactData"
        :investor-contact-required="blok.investorContactRequired"
      />
    </div>
    <SbMediaCentreAboutBlock />
  </div>
</template>

<script setup lang="ts">
import type { ISbRichtext } from "storyblok-js-client";

const props = defineProps<{
  blok: {
    title: string;
    mediaContact: string;
    investorContactRequired: boolean;
    investorContact: string;
    publishedDate: string;
    tags: string[];
    articleContent: ISbRichtext;
    hideImage: boolean;
    image?: {
      filename: string;
      alt: string;
    };
  };
  publishedAt?: string;
  parentId?: number;
}>();

const contactData = await getStoryblokDataUUID(
  `${props.blok.mediaContact},${props.blok.investorContact}`,
);

const mediaContactData = ref();
const investorContactData = ref();

contactData.forEach((el) => {
  if (el.uuid === props.blok.mediaContact) mediaContactData.value = el.content;
  if (el.uuid === props.blok.investorContact)
    investorContactData.value = el.content;
});

const formattedDate = new Date(props.blok.publishedDate).toLocaleDateString(
  "en-au",
  {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric",
  },
);
</script>
